import { useState } from 'react';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DataSyncAuthModal } from 'ui-universal-auth/DataSyncAuthModal';
import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DataSyncReconnectButton = ({
  buttonProps,
  label,
  metadata,
  onAuthSucceeded,
  onAuthCancelled
}) => {
  const [open, setOpen] = useState(false);
  const portalId = PortalIdParser.get();
  const appId = metadata === null || metadata === void 0 ? void 0 : metadata.appId;
  const accountId = metadata === null || metadata === void 0 ? void 0 : metadata.accountId;
  if (!appId || !portalId) {
    if (enviro.isQa()) {
      console.warn('DataSyncReconnectButton: Missing required props or gated', {
        appId: !!appId,
        portalId: !!portalId
      });
    }
    return null;
  }
  const updatedButtonProps = Object.assign({}, buttonProps, {
    loading: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.loading) || open
  });
  const handleClick = evt => {
    var _buttonProps$onClick;
    buttonProps === null || buttonProps === void 0 || (_buttonProps$onClick = buttonProps.onClick) === null || _buttonProps$onClick === void 0 || _buttonProps$onClick.call(buttonProps, evt);
    setOpen(true);
  };
  const handleCancel = () => {
    onAuthCancelled === null || onAuthCancelled === void 0 || onAuthCancelled({
      error: new Error('Reconnection was not completed'),
      errorMessage: I18n.text('reconnectionError.commonMessage'),
      queryParams: new URLSearchParams(window.location.search).toString()
    });
    setOpen(false);
  };
  const handleComplete = account => {
    onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(`${account === null || account === void 0 ? void 0 : account.id}`);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(LoadingButton, Object.assign({}, updatedButtonProps, {
      onClick: handleClick,
      children: label
    })), open && /*#__PURE__*/_jsx(DataSyncAuthModal, {
      appId: appId,
      accountId: Number(accountId),
      portalId: portalId,
      onComplete: handleComplete,
      onCancel: handleCancel
    })]
  });
};